import React, { FC, memo, ReactNode, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { StepperModal, stepperModalActions } from 'features/StepperModal';
import { TableFilterContextProvider, useTableFilterContext } from 'features/TableFilter';
import { getOpenedState } from '../model/selectors/getOpenedState';
import { getSteps } from '../model/selectors/getSteps';
import { createContractModalActions } from '../model/slice/createContractModalSlice';
import { useWatchStep } from '../utils/hooks/useWatchStep';
import { BookingOptionsStep } from './steps/BookingOptionsStep';
import { SelectUserStep } from './steps/SelectUserStep';
import { SelectWarehouseStep } from './steps/SelectWarehouseStep';
import { SelectBoxStep } from './steps/SelectBoxesStep/SelectBoxesStep';

export const CreateContractModal: FC = memo(() => {
  const dispatch = useAppDispatch();

  const isOpened = useAppSelector(getOpenedState);
  const steps = useAppSelector(getSteps);

  useWatchStep();

  const { clearAllFilters } = useTableFilterContext();

  const closeModal = useCallback(() => {
    dispatch(createContractModalActions.resetModalState());
    dispatch(stepperModalActions.changeActiveStepIndex(0));

    clearAllFilters();
  }, [dispatch, clearAllFilters]);

  const stepsContent: ReactNode[] = [
    <SelectUserStep key="1" />,
    <SelectWarehouseStep key="2" />,
    <TableFilterContextProvider key="3">
      <SelectBoxStep />
    </TableFilterContextProvider>,
    <BookingOptionsStep key="4" onClose={closeModal} />,
  ];

  return <StepperModal isOpened={isOpened} onClose={closeModal} steps={steps} stepsContent={stepsContent} width={1129} />;
});
